var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as moment from 'moment';
import { Maybe } from 'purify-ts/Maybe';
import * as api from '@codegrade/api';
import { immutable } from '@/utils';
import { CoursePrice } from './price';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
class BaseTransaction extends api.Transaction {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    canBeRefunded(price, now) {
        return this.successAt
            .map(successAt => {
            const age = moment.duration(now.diff(successAt));
            return [successAt, price.refundPeriod.clone().subtract(age)];
        })
            .chain(Maybe.fromPredicate(([, duration]) => duration.asMilliseconds() > 0));
    }
}
let Transaction = class Transaction extends BaseTransaction {
};
Transaction = __decorate([
    immutable
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], Transaction);
export { Transaction };
let ExtendedTransaction = class ExtendedTransaction extends BaseTransaction {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    shortId;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    price;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(data) {
        super(data);
        this.shortId = data.shortId;
        this.price = new CoursePrice(data.coursePrice);
    }
};
ExtendedTransaction = __decorate([
    immutable
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], ExtendedTransaction);
export { ExtendedTransaction };
